import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AadhaarOtpPageRoutingModule } from './aadhaar-otp-routing.module';

import { AadhaarOtpPage } from './aadhaar-otp.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AadhaarOtpPageRoutingModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [AadhaarOtpPage]
})
export class AadhaarOtpPageModule { }
